import React from "react";
import "./style.scss";

const Footer = ({ cookiesNotView }) => {
  return (
    <div className={`footer ${cookiesNotView ? "cookiesNotView" : ""}`}>
      <div className={"footer__content"}>
        <div>
          Cupidlee is the leading international social network for members above
          18 that helps you to build connections with users worldwide.
        </div>
        <div>
          We are here to help you meet the ones you have been looking for.
        </div>
        <div>
          Fill in brief information about yourself, confirm your registration
          and start chatting with people you like.
        </div>
        <div>
          Attention! All users must be 18+. Сontent that may offend other users
          is strictly prohibited
        </div>
      </div>
    </div>
  );
};

export default Footer;
